(function () {
  if (window.__cPdpMultifaceInit) return;
  window.__cPdpMultifaceInit = true;

  var API_URL = 'https://exeapiv2.wonderme.co/';
  var PROCESS_ENDPOINT = 'process_multiface_images/';
  var TASK_STATUS_ENDPOINT = 'task_status/';

  var POLL_INITIAL_DELAY = 3000;
  var POLL_MAX_DELAY = 5000;
  var POLL_MAX_DURATION_MS = 20 * 60 * 1000;

  // Run init AFTER DOMContentLoaded handlers of c-custom.js so we can detach
  // any listeners that may have been bound. setTimeout(0) defers to the next
  // macrotask, which is run after the synchronous DOMContentLoaded dispatch.
  function schedule() { setTimeout(init, 0); }
  if (document.readyState === 'complete') {
    schedule();
  } else {
    document.addEventListener('DOMContentLoaded', schedule);
  }

  function init() {
    // Container is identified by data-multiface (the .c-pdp-upload class is
    // temporarily stripped by an inline script in the section to keep singleface
    // c-custom.js IIFEs from binding). Restore it now so existing CSS works.
    var container = document.querySelector('[data-multiface="true"]');
    if (!container) return;
    if (container.dataset.multifaceHidden === '1') {
      container.classList.add('c-pdp-upload');
      delete container.dataset.multifaceHidden;
    }

    // Templates passed as individual data-tpl-* attributes (single JSON attribute
    // was rejected by Shopify CLI hot-reload). We read every plausible key
    // — declared keys, the inverted form (admin convention may differ), and a
    // generic "adult_{child}" fallback — to be resilient to mixed setups.
    function readTpl(suffix) {
      var camel = suffix.replace(/-(\w)/g, function (_, c) { return c.toUpperCase(); });
      return (container.dataset['tpl' + camel.charAt(0).toUpperCase() + camel.slice(1)] || '').trim();
    }
    var templates = {
      'girl_woman': readTpl('girl-woman'),
      'woman_girl': readTpl('woman-girl'),
      'boy_woman':  readTpl('boy-woman'),
      'woman_boy':  readTpl('woman-boy'),
      'girl_man':   readTpl('girl-man'),
      'man_girl':   readTpl('man-girl'),
      'boy_man':    readTpl('boy-man'),
      'man_boy':    readTpl('man-boy'),
      'girl_girl':  readTpl('girl-girl'),
      'boy_girl':   readTpl('boy-girl'),
      'girl_boy':   readTpl('girl-boy'),
      'boy_boy':    readTpl('boy-boy'),
      'adult_girl': readTpl('adult-girl'),
      'adult_boy':  readTpl('adult-boy'),
      // Adult + Adult (metafields added by the client)
      'man_woman':  readTpl('man-woman'),
      'woman_man':  readTpl('woman-man'),
      'man_man':    readTpl('man-man'),
      'woman_woman': readTpl('woman-woman')
    };
    var category = (container.dataset.category || '').trim();
    var variantId = container.dataset.currentVariantId;

    // execution_type drives which genders each slot offers and the slot labels.
    // Fallback to adult_child so products without the metafield keep working.
    var executionType = (container.dataset.executionType || 'adult_child').trim().toLowerCase();

    var GENDER_VOCAB = {
      adult_child: { p1: ['man', 'woman'], p2: ['boy', 'girl'] },
      child_child: { p1: ['boy', 'girl'],  p2: ['boy', 'girl'] },
      adult_adult: { p1: ['man', 'woman'], p2: ['man', 'woman'] }
    };
    var vocab = GENDER_VOCAB[executionType] || GENDER_VOCAB.adult_child;
    var SLOT_ROLE = {
      adult_child: { 1: 'Adult', 2: 'Child' },
      child_child: { 1: 'Child', 2: 'Child' },
      adult_adult: { 1: 'Adult', 2: 'Adult' }
    };
    // Declared up here with the other lookups, not next to resolvePair: function
    // declarations hoist, `var` initialisers do not.
    var GENDER_ROLE = { man: 'adult', woman: 'adult', boy: 'child', girl: 'child' };

    // Valid (person1, person2) gender pairs from filled templates. Defined here
    // (before initGenders() runs) because it's a runtime assignment the gender
    // helpers depend on — the hoisted functions can't see it until it executes.
    //  - specific key "{X}_{Y}" (convention {p2}_{p1}) → pair (Y, X); inverted (X, Y) too.
    //  - generic "adult_{child}" (legacy) → (categoryAdult, child), keeps the fixed adult.
    var categoryAdult = (category.split('_')[0] || '').toLowerCase();
    var pairs = (function () {
      var out = [];
      function add(p1, p2) {
        if (vocab.p1.indexOf(p1) === -1 || vocab.p2.indexOf(p2) === -1) return;
        if (!out.some(function (x) { return x[0] === p1 && x[1] === p2; })) out.push([p1, p2]);
      }
      Object.keys(templates).forEach(function (key) {
        if (!templates[key]) return;
        var parts = key.split('_'), a = parts[0], b = parts[1];
        if (a === 'adult') { add(categoryAdult, b); }
        else { add(b, a); add(a, b); }
      });
      return out;
    })();

    // Detach singleface listeners by cloning the elements c-custom.js binds to.
    var createBtn = swapElement(document.getElementById('c-pdp-create-btn'));
    var atcBtn = swapElement(document.getElementById('c-pdp-atc-btn'));
    var inlineAtcBtn = swapElement(document.getElementById('c-pdp-inline-atc'));
    var childInput = swapElement(document.getElementById('c-pdp-image-input'));
    var childInputReplace = swapElement(document.getElementById('c-pdp-image-input-replace'));
    // Singleface c-custom.js binds Try Different to reset only its single-photo
    // state. We swap it so our handler can clear BOTH adult + child photos.
    var tryDifferentBtn = swapElement(document.getElementById('c-pdp-try-different'));

    var childAgeInput = document.getElementById('c-pdp-age-input');
    var adultAgeInput = document.querySelector('[data-byteex-adult-age]');
    var generatedImg = document.getElementById('c-pdp-generated-img');
    var stepGenerating = document.querySelector('[data-step="generating"]');
    var stepResult = document.querySelector('[data-step="result"]');
    var resultContent = document.getElementById('c-pdp-result-content');
    var generationProgress = document.getElementById('c-pdp-generation-progress');
    var progressFill = document.getElementById('c-pdp-progress-fill');
    var progressText = document.getElementById('c-pdp-progress-text');
    var progressLabel = document.getElementById('c-pdp-generation-label-text');

    if (!createBtn || !atcBtn) return;

    var selectedImageURL = '';
    var genTimers = [];
    var pollAbort = false;
    var photoGuide = null;

    listenChildInput(childInput);
    listenChildInput(childInputReplace);

    // Bind gender selectors (both slots) and do the initial render/labels.
    [1, 2].forEach(function (slot) {
      genderRadios(slot).forEach(function (r) {
        r.addEventListener('change', function () { applyEnabledState(); updateLabels(); });
      });
      // Click-to-deselect: re-clicking the already-selected option clears it, so a
      // customer can undo a choice. The radio input has pointer-events:none, so the
      // clickable element is the <label>; capture the pre-click state on mousedown.
      var wrap = document.querySelector('[data-byteex-gender-wrap="' + slot + '"]');
      if (wrap) {
        wrap.querySelectorAll('.byteex-pdp-gender-option').forEach(function (opt) {
          var input = opt.querySelector('input[type="radio"]');
          if (!input) return;
          opt.addEventListener('mousedown', function () { opt._preChecked = input.checked; });
          opt.addEventListener('click', function (e) {
            if (input.disabled) return;
            if (opt._preChecked) {
              e.preventDefault();          // cancel the label re-activating the radio
              input.checked = false;
              applyEnabledState();
              updateLabels();
            }
          });
        });
      }
    });
    initGenders();

    createBtn.disabled = false;
    createBtn.addEventListener('click', onCreateClick);
    atcBtn.addEventListener('click', onAtcClick);
    if (inlineAtcBtn) {
      inlineAtcBtn.addEventListener('click', function () {
        if (selectedImageURL) atcBtn.click();
        else window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
    if (tryDifferentBtn) {
      tryDifferentBtn.addEventListener('click', onTryDifferentClick);
    }

    // ---- Gender selection: one selector per slot, always shown ----
    // Each slot (person1 = Adult set, person2 = Child set) has its OWN gender
    // selector under its photo block. Options are the execution_type vocabulary
    // for that slot, limited to genders that have a filled template. A slot with
    // a single option is pre-selected. Slots are independent (each pairing type
    // is expected to have all its combinations); an unbuildable pick, if any,
    // is caught on Create. Labels reflect the chosen gender or the role fallback.

    function genderRadios(slot) {
      return Array.prototype.slice.call(
        document.querySelectorAll('[name="byteex-pdp-p' + slot + '-gender"]'));
    }
    function slotGender(slot) {
      var r = document.querySelector('[name="byteex-pdp-p' + slot + '-gender"]:checked');
      return r ? r.value : '';
    }
    function cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }

    function setCheckedClass(slot) {
      genderRadios(slot).forEach(function (r) {
        var opt = r.closest('.byteex-pdp-gender-option');
        if (opt) opt.classList.toggle('byteex-pdp-gender-option--checked', r.checked);
      });
    }

    // Which way round a template key reads. Two conventions sit in the data:
    //
    //   adult+child keys are written {child}_{adult}. wk25-26-gen-soaring-heroes
    //     is category=woman_boy with template_boy_woman=2fwb-20037, and the id's
    //     "wb" says person1 is the woman.
    //   same-role keys are written {p1}_{p2}. The client's adult_adult product
    //     has template_man_woman=2fmw-20047 — "mw", person1 is the man — and its
    //     child_child one has template_boy_girl=2fbg-20046.
    //
    // So: when the two roles differ the adult is person1; when they match, the
    // key already reads in person order. For a same-role pair the key order is
    // therefore significant — it must match the artwork, and the template id's
    // two initials are the cross-check.
    function canonicalOrder(a, b) {
      if (GENDER_ROLE[a] === 'child' && GENDER_ROLE[b] === 'adult') return [b, a];
      return [a, b];
    }

    // Admins fill only one of a pair's two orderings, so a customer who picks it
    // the other way round has to be sent reversed. `swap` says whether that
    // happened. It matters because the AI backend locates a template's image
    // folder by the gender order it was uploaded under: the reversed order fails
    // with "No template images found in the folder." (client_id 481804688_2 and
    // 268640205_7), while reusing the template name and leaving the photos in
    // place would generate artwork with each face in the other's position —
    // worse, because nothing surfaces until it comes back.
    function resolvePair(g1, g2) {
      var candidates = [g1 + '_' + g2, g2 + '_' + g1];
      for (var i = 0; i < candidates.length; i++) {
        var key = candidates[i];
        if (!templates[key]) continue;
        var parts = key.split('_');
        var canon = canonicalOrder(parts[0], parts[1]);
        return { key: key, name: templates[key], swap: canon[0] !== g1 };
      }
      // Generic legacy alias, declared only as adult_{child}.
      if (templates['adult_' + g2]) return { key: 'adult_' + g2, name: templates['adult_' + g2], swap: false };
      if (templates['adult_' + g1]) return { key: 'adult_' + g1, name: templates['adult_' + g1], swap: true };
      return null;
    }

    // Show a slot's full execution_type vocabulary (2 genders); hide only genders
    // that don't belong to this type (e.g. boy/girl for adult_adult). Availability
    // is expressed via enable/disable, not hiding — see applyEnabledState().
    function showSlotVocab(slot) {
      var allowed = vocab['p' + slot];
      genderRadios(slot).forEach(function (r) {
        var opt = r.closest('.byteex-pdp-gender-option') || r.parentNode;
        var inVocab = allowed.indexOf(r.value) !== -1;
        if (opt) opt.style.display = inVocab ? '' : 'none';
        if (!inVocab && r.checked) r.checked = false;
      });
      var wrap = document.querySelector('[data-byteex-gender-wrap="' + slot + '"]');
      if (wrap) wrap.style.display = '';
    }

    // Is there a filled template pairing `g` in `slot` with the other slot's `other`
    // gender? `other === ''` means the other slot has no selection yet (any).
    function pairExists(slot, g, other) {
      return pairs.some(function (p) {
        return slot === 1
          ? (p[0] === g && (other === '' || p[1] === other))
          : (p[1] === g && (other === '' || p[0] === other));
      });
    }

    // Enable/disable each shown option per slot based on filled templates and the
    // OTHER slot's current selection. Unchecks a now-invalid selection. No auto-
    // selection — the customer always chooses (and can clear) each gender explicitly.
    function applyEnabledState() {
      [1, 2].forEach(function (slot) {
        var other = slotGender(slot === 1 ? 2 : 1);
        genderRadios(slot).forEach(function (r) {
          var opt = r.closest('.byteex-pdp-gender-option');
          if (opt && opt.style.display === 'none') return; // outside this type's vocab
          var ok = pairExists(slot, r.value, other);
          r.disabled = !ok;
          if (opt) opt.classList.toggle('byteex-pdp-gender-option--disabled', !ok);
          if (!ok && r.checked) r.checked = false;
        });
        setCheckedClass(slot);
      });
    }

    function updateLabels() {
      [1, 2].forEach(function (slot) {
        var el = document.querySelector('[data-byteex-slot-title="' + slot + '"]');
        if (!el) return;
        var g = slotGender(slot);
        el.textContent = g ? cap(g) : ((SLOT_ROLE[executionType] || SLOT_ROLE.adult_child)[slot]);
      });
    }

    function initGenders() {
      showSlotVocab(1);
      showSlotVocab(2);
      applyEnabledState();
      updateLabels();
    }

    function listenChildInput(input) {
      if (!input) return;
      input.addEventListener('change', function (e) {
        var file = e.target.files && e.target.files[0];
        // Clear value so re-selecting the same file fires 'change' on
        // Safari/iOS (mirrors byteex-pdp-adult-set.js:75 behaviour).
        e.target.value = '';
        if (!file || file.type.indexOf('image') !== 0) return;
        var reader = new FileReader();
        reader.onload = function (evt) {
          compressImage(evt.target.result, 2000, 0.7).then(function (compressed) {
            try { localStorage.setItem('uploadedImage', compressed); } catch (_) {}
            var thumb = document.getElementById('c-pdp-thumb');
            if (thumb) thumb.src = compressed;
            // Switch child block from upload-state to preview-state
            var childUpload = document.querySelector('.byteex-pdp-set--child [data-step="upload"]');
            var childPrev = document.querySelector('.byteex-pdp-set--child [data-step="preview"]');
            if (childUpload) childUpload.style.display = 'none';
            if (childPrev) childPrev.style.display = '';
          });
        };
        reader.readAsDataURL(file);
      });
    }

    function onCreateClick() {
      var adultBase64 = safeLocalGet('uploadedImageAdult');
      var childBase64 = safeLocalGet('uploadedImage');
      var adultAge = adultAgeInput && adultAgeInput.value ? parseInt(adultAgeInput.value, 10) : NaN;
      var childAge = childAgeInput && childAgeInput.value ? parseInt(childAgeInput.value, 10) : NaN;
      // person1 = first (adult) set; person2 = second (child) set.
      var g1 = slotGender(1);
      var g2 = slotGender(2);

      if (!adultBase64) return showError('Please upload the first photo');
      if (!childBase64) return showError('Please upload the second photo');
      if (!adultAge || adultAge < 1 || adultAge > 100) return showError('Please enter the first person\'s age');
      if (!childAge || childAge < 1 || childAge > 100) return showError('Please enter the second person\'s age');
      if (!g1) return showError('Please choose the first gender');
      if (!g2) return showError('Please choose the second gender');

      var resolved = resolvePair(g1, g2);
      if (!resolved) {
        return showError('No template configured for ' + cap(g1) + ' + ' + cap(g2));
      }
      var templateName = resolved.name;

      // Photo, gender and age move together as one person — the template fixes
      // who stands where, so splitting them up would put each face in the
      // other's position.
      var slot1 = { img: adultBase64, age: adultAge, gender: g1 };
      var slot2 = { img: childBase64, age: childAge, gender: g2 };
      var p1 = resolved.swap ? slot2 : slot1;
      var p2 = resolved.swap ? slot1 : slot2;
      if (resolved.swap) {
        console.info('[ImageGen-multiface] ' + g1 + '+' + g2 + ' served by template_' +
          resolved.key + ' — person1/person2 sent swapped');
      }

      enterGeneratingState();

      // Retry-on-failure: rotate uniqueUserId and resend the request to
      // dodge potential collisions with another live user's userId.
      // Mirrors singleface c-custom.js#L498-L519.
      var MAX_RETRIES = 2;
      var retryCount = 0;
      var attemptGen = 0;
      var compressedCache = null;

      function handleFailure(reason) {
        clearGenTimers();
        if (retryCount < MAX_RETRIES) {
          retryCount++;
          console.warn('[ImageGen-multiface] Retry ' + retryCount + '/' + MAX_RETRIES + ' after: ' + reason);
          localStorage.setItem('uniqueUserId', Math.floor(Math.random() * 1000000000).toString());
          attemptRequest();
          return;
        }
        onError();
      }

      function attemptRequest() {
        attemptGen++;
        var myGen = attemptGen;
        function isStale() { return myGen !== attemptGen; }

        var compressPromise = compressedCache
          ? Promise.resolve(compressedCache)
          : Promise.all([
              compressImage(p1.img, 2000, 0.7),
              compressImage(p2.img, 2000, 0.7)
            ]).then(function (r) { compressedCache = r; return r; });

        compressPromise
          .then(function (results) {
            if (isStale()) return;

            // Filenames stay keyed to the person slot, not to the customer's
            // pick order, so a swapped request is byte-identical to the one the
            // matching forward pick produces.
            var person1File = new File([base64ToBlob(results[0])], 'adult.jpg', { type: 'image/jpeg' });
            var person2File = new File([base64ToBlob(results[1])], 'child.jpg', { type: 'image/jpeg' });

            var userId = generateUserId();

            var fd = new FormData();
            fd.append('user_id', userId);
            fd.append('category', category);
            fd.append('template_name', templateName);
            fd.append('gender1', p1.gender);
            fd.append('age1', String(p1.age));
            fd.append('gender2', p2.gender);
            fd.append('age2', String(p2.age));
            fd.append('tagger_prompt_1', '');
            fd.append('tagger_prompt_2', '');
            fd.append('person1', person1File);
            fd.append('person2', person2File);

            return fetch(API_URL + PROCESS_ENDPOINT, { method: 'POST', body: fd })
              .then(function (r) {
                return r.json().then(function (j) { return { ok: r.ok, body: j }; });
              })
              .then(function (res) {
                if (isStale()) return;
                if (!res.ok) {
                  throw new Error('Multiface request rejected: ' + JSON.stringify(res.body));
                }
                return pollUntilDone(userId, isStale);
              });
          })
          .then(function (imageUrl) {
            if (isStale()) return;
            if (imageUrl) onComplete(imageUrl);
          })
          .catch(function (err) {
            if (isStale()) return;
            console.error('[c-pdp-multiface]', err);
            handleFailure((err && err.message) || 'request error');
          });
      }

      attemptRequest();
    }

    // Mirrors singleface c-custom.js#L495-L574 progress + polling pattern:
    //   1) After POST returns, ramp 0 -> 60% (+1% every 225ms)
    //   2) On reaching 60%, start polling task_status
    //   3) On each poll response (while still processing): start an additional
    //      +1%/720ms ramp toward 100%, then re-poll with backoff
    //   4) On status='success' -> resolve with image url (caller sets 100%)
    function pollUntilDone(userId, isStale) {
      isStale = isStale || function () { return false; };
      var startedAt = Date.now();
      var progress = 0;
      var pollingDelay = 1000;
      var isCompleted = false;
      pollAbort = false;

      return new Promise(function (resolve, reject) {
        var progressInterval = setInterval(function () {
          if (isStale()) { clearInterval(progressInterval); return; }
          if (progress < 60) progress += 1;
          progress = Math.min(progress, 60);
          setProgress(progress);
          if (progress >= 60) {
            clearInterval(progressInterval);
            pollStatus();
          }
        }, 225);
        genTimers.push(progressInterval);

        function pollStatus() {
          if (isStale()) return;
          if (isCompleted || pollAbort) return;
          if (Date.now() - startedAt > POLL_MAX_DURATION_MS) {
            return reject(new Error('timeout: generation took more than 20 minutes'));
          }
          fetch(API_URL + TASK_STATUS_ENDPOINT + encodeURIComponent(userId))
            .then(function (r) { return r.json(); })
            .then(function (data) {
              if (isStale()) return;
              var status = data && data.status;
              if (status === 'success') {
                isCompleted = true;
                clearGenTimers();
                var msg = data.message;
                var urls = (msg && msg.presigned_urls) || [];
                if (!urls.length) return reject(new Error('no presigned_urls in success'));
                resolve(urls[0]);
                return;
              }
              if (status === 'failed' || status === 'error' || status === 'rejected') {
                clearGenTimers();
                var msg2 = data.message;
                var detail = (msg2 && (msg2.message || msg2)) || 'failed';
                return reject(new Error(typeof detail === 'string' ? detail : JSON.stringify(detail)));
              }
              // queued / processing — bump progress toward 100% (additive ramp)
              if (progress < 100) {
                var pollingInterval = setInterval(function () {
                  if (isStale()) { clearInterval(pollingInterval); return; }
                  progress += 1;
                  progress = Math.min(progress, 100);
                  setProgress(progress);
                }, 720);
                genTimers.push(pollingInterval);
                pollingDelay = Math.min(pollingDelay * 1.5, 5000);
                var t = setTimeout(pollStatus, pollingDelay);
                genTimers.push(t);
              } else if (progress >= 100 && (status === 'queued' || status === 'processing')) {
                var t2 = setTimeout(pollStatus, pollingDelay);
                genTimers.push(t2);
              }
            })
            .catch(function (err) {
              if (isStale()) return;
              reject(err);
            });
        }
      });
    }

    function enterGeneratingState() {
      // Minimal-shift transition: keep Adult + Child blocks (photo previews,
      // age, gender) untouched so the page doesn't jump. Only swap the Create
      // button area for the progress bar.
      // NOTE: [data-step="generating"] markup contains its own child-thumb
      // mini-card (singleface artefact); we hide it and show only the
      // bare progress banner.
      clearGenTimers();
      pollAbort = false;
      if (stepGenerating) stepGenerating.style.display = 'none';
      if (stepResult) stepResult.style.display = 'none';
      if (resultContent) resultContent.style.display = 'none';
      if (generationProgress) generationProgress.style.display = '';
      if (progressLabel) progressLabel.textContent = 'Generating your portrait';
      setProgress(0);
      createBtn.style.display = 'none';
      atcBtn.style.display = 'none';
      if (inlineAtcBtn) {
        inlineAtcBtn.style.display = 'none';
        inlineAtcBtn.dataset.ready = '';
      }
    }

    function onComplete(imageUrl) {
      selectedImageURL = imageUrl;
      clearGenTimers();
      setProgress(100);
      if (generatedImg) generatedImg.src = imageUrl;
      if (generationProgress) generationProgress.style.display = 'none';
      if (stepGenerating) stepGenerating.style.display = 'none';
      // stepResult holds a child-thumb mini-card (singleface artefact) — keep hidden.
      if (stepResult) stepResult.style.display = 'none';
      if (resultContent) resultContent.style.display = '';
      // Keep child preview/age/gender visible to avoid layout jump; they're
      // still meaningful context.
      createBtn.style.display = 'none';
      atcBtn.style.display = 'none';
      atcBtn.disabled = !variantId;
      if (inlineAtcBtn) {
        inlineAtcBtn.style.display = '';
        inlineAtcBtn.dataset.ready = 'true';
        inlineAtcBtn.disabled = !variantId;
      }
      saveHistory(imageUrl);
    }

    // Reset BOTH adult + child upload state and bring the UI back to the
    // initial pre-upload state. Bound to #c-pdp-try-different (after the
    // singleface c-custom.js handler has been stripped via swapElement).
    function onTryDifferentClick() {
      clearGenTimers();
      pollAbort = true;
      selectedImageURL = '';
      if (window.PhotoGuide) PhotoGuide.hide(photoGuide, container);

      // Clear both photo blobs from localStorage so onCreateClick's
      // safeLocalGet('uploadedImage'/'uploadedImageAdult') returns empty
      // and the validation in onCreateClick re-asks for new photos.
      try { localStorage.removeItem('uploadedImage'); } catch (_) {}
      try { localStorage.removeItem('uploadedImageAdult'); } catch (_) {}

      // Adult set: show upload step, hide preview step, clear thumb.
      var adultUpload = document.querySelector('.byteex-pdp-set--adult [data-byteex-adult-step="upload"]');
      var adultPreview = document.querySelector('.byteex-pdp-set--adult [data-byteex-adult-step="preview"]');
      if (adultUpload) adultUpload.style.display = '';
      if (adultPreview) adultPreview.style.display = 'none';
      var adultThumb = document.querySelector('[data-byteex-adult-thumb]');
      if (adultThumb) adultThumb.src = '';

      // Child set: show upload step, hide preview step, clear thumb.
      var childUpload = document.querySelector('.byteex-pdp-set--child [data-step="upload"]');
      var childPreview = document.querySelector('.byteex-pdp-set--child [data-step="preview"]');
      if (childUpload) childUpload.style.display = '';
      if (childPreview) childPreview.style.display = 'none';
      var childThumb = document.getElementById('c-pdp-thumb');
      if (childThumb) childThumb.src = '';

      // Clear age inputs and both gender selectors, then re-run the prune so a
      // single-available gender re-auto-selects (and labels reset).
      if (adultAgeInput) adultAgeInput.value = '';
      if (childAgeInput) childAgeInput.value = '';
      [1, 2].forEach(function (slot) {
        genderRadios(slot).forEach(function (r) { r.checked = false; });
      });
      // Programmatic .checked = false doesn't fire 'change', so the
      // --checked CSS class would linger; clear it manually. initGenders
      // re-renders and re-selects a single option where applicable.
      document.querySelectorAll('.byteex-pdp-gender-option--checked').forEach(function (el) {
        el.classList.remove('byteex-pdp-gender-option--checked');
      });
      initGenders();

      // Hide result + generating panels so the next generation cycle
      // re-renders them (preview button is a child of resultContent, so
      // it reappears automatically on the next success).
      if (resultContent) resultContent.style.display = 'none';
      if (generationProgress) generationProgress.style.display = 'none';
      if (stepGenerating) stepGenerating.style.display = 'none';
      if (stepResult) stepResult.style.display = 'none';

      // Restore Create button, hide ATC variants.
      createBtn.style.display = '';
      createBtn.disabled = false;
      atcBtn.style.display = 'none';
      atcBtn.disabled = true;
      if (inlineAtcBtn) {
        inlineAtcBtn.style.display = 'none';
        inlineAtcBtn.dataset.ready = '';
        inlineAtcBtn.disabled = true;
      }

      setProgress(0);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function onError() {
      clearGenTimers();
      pollAbort = true;
      if (generationProgress) generationProgress.style.display = 'none';
      if (stepGenerating) stepGenerating.style.display = 'none';
      if (resultContent) resultContent.style.display = 'none';
      if (stepResult) stepResult.style.display = 'none';
      atcBtn.style.display = 'none';
      if (inlineAtcBtn) {
        inlineAtcBtn.style.display = 'none';
        inlineAtcBtn.dataset.ready = '';
      }
      if (window.PhotoGuide) {
        var data = PhotoGuide.readData(container.dataset.sectionId);
        photoGuide = PhotoGuide.ensure(container, data, 'c-pdp-guide-' + (container.dataset.sectionId || 'b'), onTryDifferentClick);
        createBtn.style.display = 'none';
        PhotoGuide.show(photoGuide, container);
        return;
      }
      createBtn.style.display = '';
      showError('Generation failed. Please try again.');
    }

    function onAtcClick() {
      if (!variantId || !selectedImageURL) return;
      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding...';

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var items = [{
        id: variantId,
        quantity: 1,
        properties: {
          _selected_image: selectedImageURL,
          _is_multiface: 'true'
        }
      }];

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          localStorage.setItem('cartUpdated', 'true');
          var path = window.location.pathname;
          var match = path.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?)(?=\/|$)/i);
          var prefix = match ? match[0] : '';
          window.location.href = prefix + '/';
        })
        .catch(function () {
          atcBtn.disabled = false;
          atcBtn.textContent = 'ADD TO CART';
          showError('Error adding to cart. Please try again.');
        });
    }

    function setProgress(pct) {
      if (progressFill) progressFill.style.width = pct + '%';
      if (progressText) progressText.textContent = pct + '%';
    }

    function clearGenTimers() {
      genTimers.forEach(function (id) { clearTimeout(id); clearInterval(id); });
      genTimers = [];
    }

    function saveHistory(imageUrl) {
      try {
        var uniqueUserId = localStorage.getItem('uniqueUserId') || '';
        var entry = {
          productId: null,
          productTitle: document.title,
          productUrl: window.location.href,
          imageUrl: xorEncrypt(imageUrl),
          isMultiface: true,
          adultAge: adultAgeInput ? adultAgeInput.value : '',
          childAge: childAgeInput ? childAgeInput.value : ''
        };
        var existing = JSON.parse(localStorage.getItem('userCanvas') || '[]');
        if (!Array.isArray(existing)) existing = [];
        var found = existing.find(function (e) { return e.uniqueUserId === uniqueUserId; });
        if (found) {
          found.processdImages = found.processdImages || [];
          found.processdImages.push(entry);
        } else {
          existing.push({ uniqueUserId: uniqueUserId, processdImages: [entry] });
        }
        localStorage.setItem('userCanvas', JSON.stringify(existing));
      } catch (_) {}
    }
  }

  // Replace an element with a deep clone to strip foreign event listeners.
  // Returns the new node (or null if input was null).
  function swapElement(el) {
    if (!el || !el.parentNode) return el || null;
    var clone = el.cloneNode(true);
    el.parentNode.replaceChild(clone, el);
    return clone;
  }

  function safeLocalGet(key) {
    try { return localStorage.getItem(key); } catch (_) { return null; }
  }

  function generateUserId() {
    var uid = safeLocalGet('uniqueUserId');
    if (!uid) {
      uid = Math.floor(Math.random() * 1000000).toString();
      try { localStorage.setItem('uniqueUserId', uid); } catch (_) {}
    }
    var count = parseInt(safeLocalGet('uploadedCount') || '0', 10) + 1;
    try { localStorage.setItem('uploadedCount', String(count)); } catch (_) {}
    return uid + '_' + count;
  }

  function compressImage(src, maxSize, quality) {
    maxSize = maxSize || 2000;
    quality = quality || 0.7;
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.onload = function () {
        var w = img.width, h = img.height;
        if (w > maxSize || h > maxSize) {
          if (w > h) { h = Math.round((h * maxSize) / w); w = maxSize; }
          else { w = Math.round((w * maxSize) / h); h = maxSize; }
        }
        var c = document.createElement('canvas');
        c.width = w; c.height = h;
        c.getContext('2d').drawImage(img, 0, 0, w, h);
        resolve(c.toDataURL('image/jpeg', quality));
      };
      img.onerror = reject;
      img.src = src;
    });
  }

  function base64ToBlob(b64) {
    var parts = b64.split(',');
    var bytes = atob(parts[1]);
    var arr = new Uint8Array(bytes.length);
    for (var i = 0; i < bytes.length; i++) arr[i] = bytes.charCodeAt(i);
    return new Blob([arr], { type: 'image/jpeg' });
  }

  function xorEncrypt(text) {
    var key = 'p?c7=pAc0v6F';
    var result = '';
    for (var i = 0; i < text.length; i++) {
      result += String.fromCharCode(text.charCodeAt(i) ^ key.charCodeAt(i % key.length));
    }
    return btoa(result);
  }

  function showError(message) {
    var popup = document.getElementById('c-pdp-error-popup');
    var created = false;
    if (!popup) {
      created = true;
      popup = document.createElement('div');
      popup.id = 'c-pdp-error-popup';
      popup.style.cssText = [
        'position:fixed', 'background:#fff', 'color:#d32f2f',
        'border:1.5px solid #d32f2f', 'border-radius:10px',
        'padding:10px 16px', 'font-size:14px', 'font-weight:600',
        'box-shadow:0 6px 24px rgba(0,0,0,0.18)', 'z-index:99999',
        'opacity:0', 'pointer-events:none',
        'transition:opacity 0.25s ease, transform 0.25s ease',
        'display:inline-flex', 'align-items:center', 'gap:10px',
        'line-height:1.2', 'max-width:calc(100vw - 24px)'
      ].join(';');
      var textEl = document.createElement('span');
      textEl.id = 'c-pdp-error-popup-text';
      popup.appendChild(textEl);
      document.body.appendChild(popup);
    }
    var textEl = document.getElementById('c-pdp-error-popup-text');
    if (textEl) textEl.textContent = message;

    var anchor = document.getElementById('c-pdp-atc-btn');
    if (!anchor || anchor.offsetParent === null) anchor = document.getElementById('c-pdp-create-btn');
    if (anchor && anchor.offsetParent !== null) {
      var rect = anchor.getBoundingClientRect();
      var top = rect.top - popup.offsetHeight - 12;
      if (top < 8) top = rect.bottom + 12;
      var left = Math.max(12, Math.min(window.innerWidth - popup.offsetWidth - 12,
        rect.left + rect.width / 2 - popup.offsetWidth / 2));
      popup.style.left = left + 'px';
      popup.style.top = top + 'px';
    } else {
      popup.style.left = '50%';
      popup.style.top = '20px';
      popup.style.transform = 'translateX(-50%)';
    }

    requestAnimationFrame(function () { popup.style.opacity = '1'; });
    clearTimeout(showError._t);
    showError._t = setTimeout(function () { popup.style.opacity = '0'; }, 3500);
  }
})();
